import React, { forwardRef } from "react";

type Props = React.PropsWithChildren<
	React.ButtonHTMLAttributes<HTMLButtonElement>
>;

/**
 * Button コンポーネント
 * @returns {JSX.Element} Button コンポーネント
 */
export default forwardRef<HTMLButtonElement, Props>(
	function Button(props, ref) {
		const { children, ...rest } = props;

		return (
			<button type="submit" {...rest} ref={ref}>
				{children}
			</button>
		);
	},
);
